import React, { useEffect, useState } from "react";
import { SET_LOADING } from "../../redux/user";
import { useDispatch } from "react-redux";
import { api_paths } from "../../config/api.paths";
import { toastErrorMessage } from "../../utils/utils";
import API from "../../config/axios";

const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

const ByLaws = () => {
  const [page, setPage] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const dispatch = useDispatch();

  const getPageDetails = async (identifier) => {
    setIsLoading(true);
    setLoadError("");
    dispatch(SET_LOADING(true));
    try {
      const response = await API.get(`${api_paths.GET_CMS_PAGE}${identifier}`);
      if (response?.data?.payload?.result) {
        setPage(response?.data?.payload?.result);
      } else {
        setLoadError("No bylaws document available.");
      }
    } catch (error) {
      console.log(error);
      const message =
        error?.response?.data?.message || "Failed to load bylaws.";
      setLoadError(message);
      toastErrorMessage(message);
    } finally {
      setIsLoading(false);
      dispatch(SET_LOADING(false));
    }
  };

  useEffect(() => {
    getPageDetails("BYLAW"); // BYLAW term_condition about_us
    // eslint-disable-next-line
  }, []);

  return (
    <div className="container-fluid px-0">
      {isLoading && <div className="text-center py-5">Loading bylaws...</div>}

      {!isLoading && loadError && (
        <div className="text-center py-5 text-danger">{loadError}</div>
      )}

      {!isLoading && !loadError && page?.file_path && (
        <iframe
          src={`${IMAGE_BASEURL}${page.file_path}`}
          title="bylaws"
          width="100%"
          height="800px"
          frameBorder="0"
        />
      )}
    </div>
  );
};

export default ByLaws;
